module.exports = __webpack_public_path__ + "public/images/icon-instagram.140ccccb61a3088473eabb81a8a6e772.svg";